import { createActions } from 'redux-actions'

export const INIT_AUTHEN_INFO = "INIT_AUTHEN_INFO";

export const REQUEST_PING_START = "REQUEST_PING_START";
export const REQUEST_PING_SUCCESS = "REQUEST_PING_SUCCESS";
export const REQUEST_PING_FAIL = "REQUEST_PING_FAIL";

export const AUTHEN_IDEL = "AUTHEN_IDEL";
export const AUTHEN_START = "AUTHEN_START";
export const AUTHEN_SUCCESS = "AUTHEN_SUCCESS";
export const AUTHEN_FAIL = "AUTHEN_FAIL";

export const REQUEST_LOGOUT_START = "REQUEST_LOGOUT_START";
export const REQUEST_LOGOUT_SUCCESS = "REQUEST_LOGOUT_SUCCESS";
export const REQUEST_LOGOUT_FAIL = "REQUEST_LOGOUT_FAIL";

// export const REQUEST_ROLE_PERMISSION_START = "REQUEST_ROLE_PERMISSION_START";
// export const REQUEST_ROLE_PERMISSION_SUCCESS = "REQUEST_ROLE_PERMISSION_SUCCESS";
// export const REQUEST_ROLE_PERMISSION_FAIL = "REQUEST_ROLE_PERMISSION_FAIL";

// export const SET_ROLE_PERMISSION_START = "SET_ROLE_PERMISSION_START";
// export const SET_ROLE_PERMISSION_SUCCESS = "SET_ROLE_PERMISSION_SUCCESS";
// export const SET_ROLE_PERMISSION_FAIL = "SET_ROLE_PERMISSION_FAIL";


export const {
  initAuthenInfo,

  requestPingStart,
  requestPingSuccess,
  requestPingFail,

  authenIdel,
  authenStart,
  authenSuccess,
  authenFail,

  requestLogoutStart,
  requestLogoutSuccess,
  requestLogoutFail,

  // requestRolePermissionStart,
  // requestRolePermissionSuccess,
  // requestRolePermissionFail,

  // setRolePermissionStart,
  // setRolePermissionSuccess,
  // setRolePermissionFail,

} = createActions({

  [INIT_AUTHEN_INFO]: (req) => ({ req }),

  [REQUEST_PING_START]: (req) => ({ ...req }),
  [REQUEST_PING_SUCCESS]: (res) => ({ res }),
  [REQUEST_PING_FAIL]: (res) => ({ res }),

  [AUTHEN_IDEL]: (req) => ({ ...req }),
  [AUTHEN_START]: (req) => ({ ...req }),
  [AUTHEN_SUCCESS]: (res) => ({ res }),
  [AUTHEN_FAIL]: (res) => ({ res }),

  [REQUEST_LOGOUT_START]: (req) => ({ ...req }),
  [REQUEST_LOGOUT_SUCCESS]: (res) => ({ res }),
  [REQUEST_LOGOUT_FAIL]: (res) => ({ res }),

  // [REQUEST_ROLE_PERMISSION_START]: (req) => ({ ...req }),
  // [REQUEST_ROLE_PERMISSION_SUCCESS]: (res) => ({ res }),
  // [REQUEST_ROLE_PERMISSION_FAIL]: (res) => ({ res }),

  // [SET_ROLE_PERMISSION_START]: (req) => ({ ...req }),
  // [SET_ROLE_PERMISSION_SUCCESS]: (res) => ({ res }),
  // [SET_ROLE_PERMISSION_FAIL]: (res) => ({ res }),

})

